import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Clientes</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Clientes</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body row" }
const _hoisted_11 = { class: "form-group col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "id" }, "Código:    ", -1)
const _hoisted_13 = { class: "form-group col-12 col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Situação:    ", -1)
const _hoisted_15 = { class: "form-group col-12 col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "cnpj" }, "CNPJ:    ", -1)
const _hoisted_17 = { class: "form-group col-12 col-md-6" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "type_description" }, "Tipo:    ", -1)
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "company" }, "Razão social:    ", -1)
const _hoisted_21 = { class: "form-group col-12 col-md-6" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "trade_name" }, "Nome fantasia:    ", -1)
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "inscricao_estadual" }, "Inscrição estadual:    ", -1)
const _hoisted_25 = { class: "form-group col-12 col-md-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "inscricao_municipal" }, "Inscrição municipal:    ", -1)
const _hoisted_27 = { class: "form-group col-12 col-md-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "segment_description" }, "Segmento:    ", -1)
const _hoisted_29 = { class: "form-group col-12 col-md-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "economic_sector_description" }, "Setor econômico:    ", -1)
const _hoisted_31 = { class: "form-group col-12 col-md-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "partner" }, "Parceiro:    ", -1)
const _hoisted_33 = { class: "form-group col-12 col-md-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "finance_credit" }, "Crédito financeiro:    ", -1)
const _hoisted_35 = { class: "form-group col-12 col-md-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "street_name" }, "Endereço:    ", -1)
const _hoisted_37 = { class: "form-group col-12 col-md-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "complement" }, "Complemento:    ", -1)
const _hoisted_39 = { class: "form-group col-12 col-md-6" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "district" }, "Bairro:    ", -1)
const _hoisted_41 = { class: "form-group col-12 col-md-6" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "zip_code" }, "Código postal:    ", -1)
const _hoisted_43 = { class: "form-group col-12 col-md-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "city" }, "Cidade:    ", -1)
const _hoisted_45 = { class: "form-group col-12 col-md-6" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "state" }, "Estado:    ", -1)
const _hoisted_47 = { class: "form-group col-12" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Observações:    ", -1)
const _hoisted_49 = { class: "card-footer text-center" }
const _hoisted_50 = { class: "btn-group" }
const _hoisted_51 = { class: "card card-success card-outline" }
const _hoisted_52 = { class: "card-header" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-card" }),
  /*#__PURE__*/_createTextVNode(" Contatos ")
], -1)
const _hoisted_54 = { class: "card-tools" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "card-body row body-table-list" }
const _hoisted_58 = { class: "table-list" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"50px"} }, "ID"),
  /*#__PURE__*/_createElementVNode("th", null, "Nome"),
  /*#__PURE__*/_createElementVNode("th", null, "E-mail"),
  /*#__PURE__*/_createElementVNode("th", null, "Telefone"),
  /*#__PURE__*/_createElementVNode("th", null, "Tipo"),
  /*#__PURE__*/_createElementVNode("th", null, "Situação"),
  /*#__PURE__*/_createElementVNode("th")
], -1)
const _hoisted_60 = {
  class: "table-button-container",
  style: {"text-align":"center"}
}
const _hoisted_61 = { class: "btn-group" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, "Clientes | " + _toDisplayString(_ctx.id), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: "Voltar"
              }, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.row.id), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
              'bg-success': _ctx.row.enabled,
              'bg-danger': !_ctx.row.enabled
            }])
              }, _toDisplayString(_ctx.row.enabled ? 'Ativo' : 'Inativo'), 3)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.row.cnpj), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.row.type_description), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createTextVNode(" " + _toDisplayString(_ctx.row.company), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(_ctx.row.trade_name), 1)
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createTextVNode(" " + _toDisplayString(_ctx.row.inscricao_estadual), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_ctx.row.inscricao_municipal), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createTextVNode(" " + _toDisplayString(_ctx.row.segment_description), 1)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createTextVNode(" " + _toDisplayString(_ctx.row.economic_sector_description), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
              'bg-success': _ctx.row.partner,
              'bg-danger': !_ctx.row.partner
            }])
              }, _toDisplayString(_ctx.row.partner ? 'Sim' : 'Não'), 3)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", {
                class: _normalizeClass(["badge", {
              'bg-success': _ctx.row.finance_credit,
              'bg-warning': !_ctx.row.finance_credit
            }])
              }, _toDisplayString(_ctx.row.finance_credit ? 'Normal' : 'Bloqueado'), 3)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createTextVNode(" " + _toDisplayString(_ctx.row.street_name), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createTextVNode(" " + _toDisplayString(_ctx.row.complement), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createTextVNode(" " + _toDisplayString(_ctx.row.district), 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createTextVNode(" " + _toDisplayString(_ctx.row.zip_code), 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createTextVNode(" " + _toDisplayString(_ctx.row.city), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createTextVNode(" " + _toDisplayString(_ctx.row.state), 1)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createTextVNode(" " + _toDisplayString(_ctx.row.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-info",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.goBack()))
              }, "Voltar"),
              (_ctx.hasPermission('edit'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    id: "editarButton",
                    class: "btn btn-warning",
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.edit()))
                  }, "Editar"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              (_ctx.hasPermissionContact('create'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "newButton",
                    class: "btn btn-block btn-primary btn-xs",
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.newContact())),
                    style: {"width":"33px"},
                    "data-tooltip": "Novo"
                  }, _hoisted_56))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("table", _hoisted_58, [
              _hoisted_59,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(i.id), 1),
                  _createElementVNode("td", null, _toDisplayString(i.name), 1),
                  _createElementVNode("td", null, _toDisplayString(i.email), 1),
                  _createElementVNode("td", null, _toDisplayString(i.phone1), 1),
                  _createElementVNode("td", null, _toDisplayString(i.type_description), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", {
                  'bg-success': i.enabled,
                  'bg-danger': !i.enabled
                }])
                    }, _toDisplayString(i.enabled ? 'Ativo' : 'Inativo'), 3)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        (_ctx.hasPermissionContact('read'))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: $event => (_ctx.viewContact(i.id)),
                              class: "btn btn-sm btn-success",
                              "data-tooltip": "Abrir",
                              "data-delay": "500",
                              "data-hasqtip": "0",
                              "aria-describedby": "qtip-0"
                            }, _hoisted_64, 8, _hoisted_62))
                          : _createCommentVNode("", true),
                        (_ctx.hasPermissionContact('edit'))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: $event => (_ctx.editContact(i.id)),
                              class: "btn btn-sm btn-warning",
                              "data-tooltip": "Editar",
                              "data-delay": "500",
                              "data-hasqtip": "0",
                              "aria-describedby": "qtip-0"
                            }, _hoisted_67, 8, _hoisted_65))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}